// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2fIY0","itemTitle":"ClientEmergencyInfo_itemTitle__2bVjj","itemText":"ClientEmergencyInfo_itemText__r2PnV"};